import React, { Component } from "react";
import { Link } from "react-router-dom";

class Closed extends Component {
  render() {
    return (
      <div>
        <ul className="social">
          <Link to="/" className="button btn project-btn">
            <i className="fa fa-arrow-left"></i>Back
          </Link>
        </ul>
        <div id="faqs">
          <h1>Refresh Connections is no longer available.</h1>
          <p>
            Thank you for being part of this community. Stay safe, and keep masking
            and taking care of one another.
          </p>
          <p>
            Our customer support emails including
            help@refreshconnections.com are now closed.
          </p>
          <p>
            User data will be deleted in accordance with our{" "}
            <Link to="/terms"><strong>Terms and Conditions of Use</strong></Link>,{" "}
            <Link to="/privacy"><strong>Privacy Policy</strong></Link>, and applicable
            legal requirements. If you have any residual issues or need to contact
            us, please see the pertinent section of those documents.
          </p>
        </div>
      </div>
    );
  }
}

export default Closed;
